import * as types from './mutation-types'
import calendarService from '../../services/calendar'
import { createServiceCall } from '../actionsUtil'

export const getEventTypes = createServiceCall({
  mainAction: types.GET_EVENT_TYPES_REQUEST,
  serviceFunction: calendarService.getEventTypes,
  successAction: types.GET_EVENT_TYPES_SUCCESS,
  successDataPropery: '',
  failureAction: types.GET_EVENT_TYPES_FAILURE
})

export const getEvents = createServiceCall({
  mainAction: types.GET_EVENTS_REQUEST,
  serviceFunction: calendarService.getEvents,
  successAction: types.GET_EVENTS_SUCCESS,
  successDataPropery: '',
  failureAction: types.GET_EVENTS_FAILURE
})

export const deleteEvent = createServiceCall({
  mainAction: types.DELETE_EVENT_REQUEST,
  serviceFunction: calendarService.deleteEvent,
  successAction: types.DELETE_EVENT_SUCCESS,
  successDataPropery: '',
  failureAction: types.DELETE_EVENT_FAILURE
})
